import { Component, OnInit, OnDestroy, Directive, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subscription, BehaviorSubject, interval, Subject } from 'rxjs';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { MiscTools } from 'appshared/misc-tools';
import { ValidationTools } from 'appshared/validation-tools';
import { TextTools } from 'appshared/text-tools';
import { UITools } from 'appshared/ui-tools';

import { DocumentsService } from '../documents.service';
import { AuthService } from 'client/app/services/auth.service';

import { TableDocumentsComponent } from 'client/app/components/shared/table-documents/table-documents.component';

@Component({
	selector: 'app-document-list',
	templateUrl: './document-list.component.html',
	styleUrls: ['./document-list.component.scss']
})
export class DocumentListComponent implements OnInit, OnDestroy {
	ac = AppConstants;
	tt = TextTools;
	mt = MiscTools;
	ut = UITools;
	now = new Date();

	@ViewChild('documentsTable1') documentsTable1: TableDocumentsComponent = null;

	// 'standard' list stuff
	private userSubscription: Subscription;

	items: Models.Document[] = [];

	loading = true;
	refreshing = false;

	canAdd = false;

	constructor(
		private documentsService: DocumentsService,
		private authService: AuthService
	) { }

	// ------------------------------------------------------------------------
	ngOnInit(): void {
		this.loading = true;

		this.userSubscription = this.authService.user.subscribe((authUser) => {
			this.canAdd = authUser && ValidationTools.checkAccess(authUser, 'manage-documents');
			this.items = this.documentsService.getAll();

			this.setupItems();
		});
	}

	// ------------------------------------------------------------------------
	ngOnDestroy() {
		if (this.userSubscription) this.userSubscription.unsubscribe();
	}

	// ------------------------------------------------------------------------
	async refresh() {
		this.refreshing = true;
		try {
			await this.documentsService.refreshAll().toPromise();
			this.items = this.documentsService.getAll();
			this.setupItems();
		} catch (err: any) {
			// console.error('Caught an error refreshing list');
		}
		this.refreshing = false;
	}

	// ------------------------------------------------------------------------
	async setupItems() {
		for (const item of this.items) {
			item['__has_url'] = item.link && item.link !== '' ? 1 : 0;
			item['__has_file'] = item.file_id !== 0 ? 1 : 0;
			item['__num_orgs'] = item.org_ids.length;
			item['__num_org_groups'] = item.group_ids.length;
			item['__num_packages'] = item.package_ids.length;
		} // for

		this.loading = false;

		await MiscTools.delay(100);
		if (this.documentsTable1) this.documentsTable1.updateContent(this.items, 'WIPE-FILTER.cp-documents-list', { showProduct: true });
	}
}

